import React from "react";
import { Box } from "@mui/material";
import { GaImage } from "../../components/ui/GaImage";

export const clipFrameSx = {
  minWidth: { xs: 118, md: 168, lg: 196 },
  width: { xs: 118, md: 168, lg: 196 },
  height: { xs: 210, md: 298, lg: 348 },
};

export const podcastFrameSx = {
  minWidth: { xs: 168, md: 240, lg: 280 },
  width: { xs: 168, md: 240, lg: 280 },
  height: { xs: 95, md: 136, lg: 158 },
};

export function PosterCard({
  src,
  fallback,
  alt = "",
  eager = false,
  imageWidth,
  imageHeight,
  onClick,
  frameSx,
  children,
}) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        clipPath:
          "polygon(0 0, calc(100% - 14px) 0, 100% 14px, 100% 100%, 0 100%)",
        ...frameSx,
      }}
    >
      <GaImage
        src={src}
        fallback={fallback}
        alt={alt}
        eager={eager}
        width={imageWidth}
        height={imageHeight}
        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
      {children}
    </Box>
  );
}
